export default __webpack_public_path__ + "static/media/13 00_00_00-01_41_00.10aa9c9f.mp4";